import { UserPermissionService } from './user-permission/user-permission.service';

export const UserService = (() => {
  return {
    UserPermissionService,
  }
})();
